import querystring from 'querystring';
import React from 'react';
import config from '../config/config';
import { connect } from 'react-redux';
import {isBizzaboInternalWebsiteWhiteLabeled} from '@bizzabo/whitelabel-utils';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';
import {
    accountIdSelector,
    eventGroupIdSelector,
    eventIdSelector,
    eventUniqueNameSelector,
    onlyEventDomainSelector,
    websiteTypeSelector,
    whitelabelPathSelector,
    whitelabelUrlSelector,
    whitelabelWidgetEnabledSelector
} from '../selectors/EventSelectors';
import {ssoAccountIdSelector} from '../selectors/LoginSelectors';

const PrivateEventLoginScreen = ({
    onlyEventDomain,
    websiteType,
    whitelabelPath,
    whitelabelUrl,
    whitelabelWidgetEnabled,
    eventUniqueName,
    eventId,
    accountId,
    eventGroupId,
    ssoAccountId,
    pageReferer,
    event
}) => {
    const {'header-logo-url': imgUrl } = event;
    const internalWebsiteUrl = getInternalWebsiteBaseUrl(
        {
            websiteType,
            whitelabelWidgetEnabled,
            whitelabelUrl,
            whitelabelPath,
            onlyEventDomain,
            uniqueName: eventUniqueName,
        }
    );
    const whitelabelURL = isBizzaboInternalWebsiteWhiteLabeled({
        websiteType,
        whitelabelWidgetEnabled,
    })
        ? whitelabelUrl
        : null;
    const queryParams = querystring.stringify({
        pageReferer,
        eventId,
        groupId: eventGroupId,
        accountId,
        whitelabelURL,
        redirectTo: pageReferer,
        internalWebsiteUrl,
    });
    const urlToIDP = `${config.apiServer}/api/v2/sso/accounts/${accountId}/config/${ssoAccountId}/login-url?${queryParams}`;
    return (
        <div>
            {imgUrl &&
            <div className="private-event__logo">
                <img
                    src={imgUrl}
                    className="event-logo"
                    alt="Event Logo"
                />
            </div>
            }

            <p className="private-event__title">This is a private event for invitees only</p>
            <a href={urlToIDP} className="cta-button cta-button-medium font-size-13 custom-color color-1-background color-1-hover-opacity">Enter</a>
        </div>
    );
};

export default connect(state => ({
    onlyEventDomain: onlyEventDomainSelector(state),
    websiteType: websiteTypeSelector(state),
    whitelabelPath: whitelabelPathSelector(state),
    ssoAccountId: ssoAccountIdSelector(state),
    whitelabelUrl: whitelabelUrlSelector(state),
    eventUniqueName: eventUniqueNameSelector(state),
    accountId: accountIdSelector(state),
    eventId: eventIdSelector(state),
    eventGroupId: eventGroupIdSelector(state),
    whitelabelWidgetEnabled: whitelabelWidgetEnabledSelector(state),
}), null)(PrivateEventLoginScreen);
